import { Actions, Link } from 'ui-kit/actions'
import { LINKS, DOCS_LINK } from 'routes/constants'
import classes from './UniversalIntegrationsActions.module.scss'

export const UniversalIntegrationsActions = () => {
  return (
    <section className={classes.section}>
      <Actions className={classes.actions}>
        <Link
          href={LINKS.SCENARIOS}
          type={'secondary'}
          asPageButton
          className={classes.button}
        >
          Explore Integration Scenarios
        </Link>

        <Link
          href={DOCS_LINK}
          type={'secondary'}
          target={'_blank'}
          asPageButton
          className={classes.button}
        >
          Read Documentation
        </Link>
      </Actions>
    </section>
  )
}
